import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=55ca25e8&scoped=true"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&id=55ca25e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca25e8",
  null
  
)

export default component.exports